module.exports = __webpack_public_path__ + "img/2pachet.df1db31c.png";